// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type RequestDocumentPreviewMutationVariables = Types.Exact<{
  target: Types.DocumentPreviewTargetInput;
}>;


export type RequestDocumentPreviewMutation = { __typename?: 'Mutation', requestDocumentPreview: { __typename?: 'DocumentPreview', status: Types.DocumentPreviewStatus, renderer?: Types.DocumentPreviewRenderer | null, fileName: string, url?: string | null, expiresAt?: any | null, failureCode?: string | null } };


export const RequestDocumentPreviewDocument = gql`
    mutation RequestDocumentPreview($target: DocumentPreviewTargetInput!) {
  requestDocumentPreview(target: $target) {
    status
    renderer
    fileName
    url
    expiresAt
    failureCode
  }
}
    `;

/**
 * __useRequestDocumentPreviewMutation__
 *
 * To run a mutation, you first call `useRequestDocumentPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDocumentPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDocumentPreviewMutation, { data, loading, error }] = useRequestDocumentPreviewMutation({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useRequestDocumentPreviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestDocumentPreviewMutation, RequestDocumentPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestDocumentPreviewMutation, RequestDocumentPreviewMutationVariables>(RequestDocumentPreviewDocument, options);
      }
export type RequestDocumentPreviewMutationHookResult = ReturnType<typeof useRequestDocumentPreviewMutation>;
export type RequestDocumentPreviewMutationResult = ApolloReactCommon.MutationResult<RequestDocumentPreviewMutation>;